import { NETWORK_ICON_MAP as GLOBAL_NETWORK_ICON_MAP } from "../../../utils/networkConstants";
export const NETWORK_ICON_MAP = {
    ...GLOBAL_NETWORK_ICON_MAP,
    commision_factory: GLOBAL_NETWORK_ICON_MAP.commission_factory,
};
export const TAG_INLINE_OPTIONS = [
    { value: "", label: "No Funnel" },
    { value: "TOF", label: "TOF" },
    { value: "MOF", label: "MOF" },
    { value: "BOF", label: "BOF" },
    { value: "No Tag", label: "No Tag" },
    { value: "SPAM", label: "SPAM" },
];
export const TAG_FILTER_OPTIONS = [
    { value: "", label: "All Tags" },
    { value: "TOF", label: "TOF" },
    { value: "MOF", label: "MOF" },
    { value: "BOF", label: "BOF" },
    { value: "No Tag", label: "No Tag" },
    { value: "No Funnel", label: "No Funnel" }, // In Filter, value "No Funnel" maps to empty in backend logic
    { value: "SPAM", label: "SPAM" },
];
export const TAG_COLOR_MAP = {
    TOF: { bg: "#eff8ff", color: "#175cd3" },
    MOF: { bg: "#f0fdf4", color: "#15803d" },
    BOF: { bg: "#fdf4ff", color: "#7e22ce" },
    SPAM: { bg: "#fef2f2", color: "#b91c1c" },
    "No Funnel": { bg: "#fff7ed", color: "#c2410c" },
};
export const PUBLISHER_LINK_OPTIONS = [
    { value: "", label: "All" },
    { value: "YES", label: "Yes" },
    { value: "NO", label: "No" },
];
export const tableContainerSx = {
    border: "1px solid #EAECF0",
    borderRadius: "12px",
    overflow: "hidden",
    bgcolor: "#fff",
    "& table": { borderCollapse: "separate", borderSpacing: 0 },
    "& tr > :first-of-type": { borderLeft: "1px solid #EAECF0" },
    "& thead tr:first-of-type th": { borderTop: "1px solid #EAECF0" },
    "& thead th": { background: "#F9FAFB", position: "sticky", zIndex: 6 },
    "& tbody tr:last-of-type td": { borderBottom: "none" },
    "& tfoot td, & tfoot th": { backgroundColor: "#F9FAFB", fontWeight: 600 },
};
